import React, { Fragment } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import VerticalBar from './VerticalBar';

const SubmissionComparison = ({ months }) => {
  const lastIndex = months.length - 1;

  return (
    <div>
      <h3 className="text-sm m-b-xs text-xxs-center">
        Submission Comparison (Games vs. Non-Games)
      </h3>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              {months.map(({ label }, i) => (
                <th
                  key={label}
                  className={cx('text-xxs-center b-t b-b', { 'b-r': i !== lastIndex })}
                  colSpan="2"
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr className="text-xxs-center">
              {months.map(({ label }, i) => (
                <Fragment key={label}>
                  <td className="text-blue">Apps</td>
                  <td className={cx('text-red', { 'b-r': i !== lastIndex })}>Games</td>
                </Fragment>
              ))}
            </tr>
            <tr className="text-bottom">
              {months.map(({ label, apps, games }, i) => (
                <Fragment key={label}>
                  <td className="text-xxs-center v-a-b" style={{ height: 82 }}>
                    <div className="m-b-xxxs">{apps.toFixed(1)}%</div>
                    <VerticalBar value={apps} base={100} maxHeight={50} color="blue" width="100%" />
                  </td>
                  <td
                    className={cx('text-xxs-center v-a-b', { 'b-r': i !== lastIndex })}
                    style={{ height: 82 }}
                  >
                    <div className="m-b-xxxs">{games.toFixed(1)}%</div>
                    <VerticalBar value={games} base={100} maxHeight={50} color="red" width="100%" />
                  </td>
                </Fragment>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

SubmissionComparison.propTypes = {
  months: T.arrayOf(
    T.shape({
      label: T.string,
      apps: T.number,
      games: T.number,
    })
  ).isRequired,
};

export default SubmissionComparison;
